import { useAuthSelector } from '@providers/AuthProvider/ui/AuthProvider';
import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

interface IProtectedRouteProps extends PropsWithChildren {}

/**
 * @description Custom hook managing protected route.
 */

const ProtectedRoute: FC<IProtectedRouteProps> = (props) => {
  const { children } = props;

  const userData = useAuthSelector((state) => state.userData);
  if (!userData) {
    // user is not authenticated
    return <Navigate to="/sign-in" />;
  }

  return children;
};

export { ProtectedRoute };
